import React from 'react';
import { t, defineMessages } from '@sm/intl';
import solutionsImage from '../assets/CTM_MasterScorecard.png';
import SummarySideBar from '../SummarySideBar';
import '../summary-side-bar.scss';

const COPY = defineMessages({
  HEADLINE: {
    id: 'SolutionsSummarySideBar.headline',
    defaultMessage: 'Did you know?',
    description:
      '[Type: Header][Vis.: low] - Survey summary marketing sidebar headline',
  },
  MESSAGE: {
    id: 'SolutionsSummarySideBar.message',
    defaultMessage:
      "SurveyMonkey's market research solutions incorporate guided methodologies and AI-Powered Insights to uncover meaningful trends, fast.",
    description:
      '[Type: Paragraph][Vis.: low] - Survey summary marketing sidebar message',
  },
  CTA_TEXT: {
    id: 'SolutionsSummarySideBar.ctaText',
    defaultMessage: 'VIEW ALL SOLUTIONS',
    description:
      '[Type: Button][Vis.: low] - Survey summary marketing sidebar CTA button',
  },
});

export const SolutionsSummarySideBar: React.FC = () => {
  return (
    <SummarySideBar
      headline={t(COPY.HEADLINE)}
      message={t(COPY.MESSAGE)}
      image={() => (
        <img
          src={solutionsImage}
          className="sm-summary-side-bar__image"
          height="auto"
          alt=""
        />
      )}
      ctaText={t(COPY.CTA_TEXT)}
      ctaLink='/market-research/solutions/?ut_source=survey_summary'
    />
  );
};

export default SolutionsSummarySideBar;
